<div class='{{nodeType}} node-level-{{nodeLevel}} node' [ngClass]="{'last-child': isLastChild}" >
  <!--  Arrangement level-->
    <div class="node-row" [appHover]>
      <div class="product-name">
        <span class='clickable' *ngIf='expandable ; else not_expandable'>
          <sfc-icon name="{{expanded ? 'rds-icon-chevron-down' : 'rds-icon-chevron-right'}}"
                    (click)='onClick()' class='expandable'
                    [ngClass]="{'open-button': expanded}" size="xs"></sfc-icon>
          <span [ngClass]="{'open-text': expanded, 'detail-screen-nav': data.screenLinkIdFlag}"
                (click)="data.screenLinkIdFlag ? loadDetailPage(): null">{{data.product}}
          </span>
          <span appMeatBallMenu
                [meatBallMenuTitle]="'Product Service'"
                [requestRequiredData]="loadProductServicesRequiredData()"
                [hasBOCockpit]="data.hasBoCockpit"
                [hasMijnWonen]="data.administrationCode === '03'"
                [hasGeldOver]="data.administrationCode === '02' || data.administrationCode === '04' "
                *ngIf='data.hasProductServices || data.hasBoCockpit || hasOtherLinks.includes(data.administrationCode)'
                [attr.id]="data.iban ? data.iban : data.arrangementNumber"
                class='product-service-menu'  >
            <sfc-icon name="rds-icon-three-dots-horizontal" class='prod-serv-icon' size="sm"></sfc-icon>
          </span>
        </span>

        <ng-template #not_expandable>
          <span class='not-expandable'
                [ngClass]="{'detail-screen-nav': data.screenLinkIdFlag}"
                (click)="data.screenLinkIdFlag ? loadDetailPage(): null">{{data.product}}</span>
          <span appMeatBallMenu
                [meatBallMenuTitle]="'Product Service'"
                [requestRequiredData]="loadProductServicesRequiredData()"
                [hasBOCockpit]="data.hasBoCockpit"
                [hasMijnWonen]="data.administrationCode === '03'"
                [hasGeldOver]="data.administrationCode === '02' || data.administrationCode === '04' "
                *ngIf='data.hasProductServices || data.hasBoCockpit || hasOtherLinks.includes(data.administrationCode)'
                [attr.id]="data.iban ? data.iban : data.arrangementNumber"
                class='product-service-menu'>
                <sfc-icon name="rds-icon-three-dots-horizontal" size="sm" class='prod-serv-icon'></sfc-icon>
          </span>
        </ng-template>

      </div>
      <div #data_row class='data-row'>
        <div class='data-field number'>{{data.count}}</div>
        <div class='data-field abb' matTooltip='{{data.abbDescription}}' [matTooltipPosition]="toolTipPosition">
          {{data.abb}}
        </div>
        <div class='data-field arno'>
          <div class='non-clickable-ar-no' *ngIf="this.data.administrationCode  === '14' && this.data.commercialProductTypeCode === '0293'; else clickableLink">
            <span [attr.about]="data.iban ? data.iban : data.arrangementNumber">
              {{data.iban ? data.iban : data.arrangementNumber}}
            </span>
          </div>
          <ng-template #clickableLink>
            <span (click)="getArrangementUrl()" [attr.about]="data.iban ? data.iban : data.arrangementNumber">
              {{data.iban ? data.iban : data.arrangementNumber}}
            </span>
          </ng-template>
        </div>
        <div class="data-field copy-btn">
          <sfc-icon *ngIf='data.iban || data.arrangementNumber' [attr.title]="data.iban ? data.iban : data.arrangementNumber"
                    name='rds-icon-copy'
                    class='copyButton' appClipboard size="xs">
          </sfc-icon>
        </div>
        <div class='data-field gap-button'><span></span></div>
        <div class='data-field saldo' matTooltip="{{logHoverAmount() ? data.totalAmount : data.totalAmount |
             currency:'EUR':'symbol' }}" [matTooltipDisabled]="isBalanceToggle">
          <div *ngIf="isBalanceToggle" [ngClass]="{'red': data.totalAmount < 0}">
            {{data.restrictedData ? data.totalAmount : data.totalAmount | currency:'EUR':'symbol' }}
            {{data.totalAmount ? data.totalAmountSuffix : null}}
          </div>
          <span  *ngIf="!isBalanceToggle">
            <sfc-icon name='rds-icon-padlock-closed' size="xs"></sfc-icon>
          </span>
        </div>
        <div class='data-field gap-button'><span></span></div>
        <div class='data-field gap-button'><span></span></div>
        <div class='data-field bank'>{{data.bankCode}}</div>
        <div class='data-field gap-button'><span></span></div>
        <div class='data-field specifics'
             matTooltip='{{data.specificsLabels}}'
             [matTooltipPosition]="toolTipPosition" matTooltipClass="customtooltip">{{data.specifics}}
        </div>
        <div class='data-field status' matTooltip='{{data["statusCodeLabel"]}}'
             [matTooltipPosition]="toolTipPosition">{{data.statusCode}}</div>
        <div class='data-field relation'
             matTooltip='{{data.relationWithRole}}'
             [matTooltipPosition]="toolTipPosition"
             matTooltipClass="customtooltip"> {{data.relation}} </div>
        <div class='data-field expand-all-button'></div>

    </div>
    </div>
    <div [hidden]="!expanded" class='child-nodes'>
      <ng-container #po_node></ng-container>
    </div>
  </div>
